<template>
  <div v-if="!loading" class="min-h-screen bg-white pb-16">
    <PrintableInvoice :invoice="invoiceData" :account-relation="accountRelation" />
  </div>
</template>

<script>
import PrintableInvoice from 'Components/Invoices/PrintableInvoice.vue';

export default {
  components: {
    PrintableInvoice,
  },
  props: {
    invoiceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      invoiceData: {},
    };
  },
  computed: {
    invoice() {
      return this.$store.state.entities.invoices.byId[this.invoiceId];
    },
    account() {
      return this.$store.state.entities.accounts.byId[this.invoice.accountUuid];
    },
    accountRelation() {
      return (
        this.$store.state.entities.accountRelations.byId[this.invoice.account_relation_uuid] || null
      );
    },
  },
  created() {
    this.fetchInvoice();
  },
  methods: {
    async fetchInvoice() {
      try {
        this.setLoading(true);
        await this.$store.dispatch({
          type: 'ui/invoices/read',
          invoiceUuid: this.invoiceId,
        });
        this.setInvoiceData();
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
    setLoading(value) {
      this.loading = value;
    },
    setInvoiceData() {
      this.invoiceData = {
        number: '',
        issueDate: '',
        issuerName: '',
        issuerAddress: '',
        issuerVatNumber: '',
        issuerVatOffice: '',
        recipientName: '',
        recipientAddress: '',
        recipientVatNumber: '',
        recipientVatOffice: '',
        contactId: null,
        accountRelationUuid: null,
        ...(this.invoice || {}),
        invoiceLines: (this?.invoice?.invoiceLines || [])
          .map((invoiceLineId) => {
            if (typeof invoiceLineId === 'string') {
              const invoiceLine = this.$store.state.entities.documentLines.byId[invoiceLineId];

              return {
                ...invoiceLine,
              };
            }

            return invoiceLineId;
          })
          .filter((o) => o),
      };
    },
  },
};
</script>
